import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesTasksLinkDeleteAsyncSlice } from './delete';
import { coreInitiativesTasksLinkPostAsyncSlice } from './post';

export const coreInitiativesTasksLinkReducers = combineReducers({
	delete: coreInitiativesTasksLinkDeleteAsyncSlice.asyncReducers,
	post: coreInitiativesTasksLinkPostAsyncSlice.asyncReducers
});

export const coreInitiativesTasksLinkWatchers = combineAllWatchers([
	coreInitiativesTasksLinkDeleteAsyncSlice.asyncWatchers,
	coreInitiativesTasksLinkPostAsyncSlice.asyncWatchers
]);
